import { render, staticRenderFns } from "./FreightTableAddCarrierView.vue?vue&type=template&id=22ce769a&scoped=true"
import script from "./FreightTableAddCarrierView.vue?vue&type=script&lang=js"
export * from "./FreightTableAddCarrierView.vue?vue&type=script&lang=js"
import style0 from "./FreightTableAddCarrierView.vue?vue&type=style&index=0&id=22ce769a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce769a",
  null
  
)

export default component.exports